module.exports = __webpack_public_path__ + "img/logo.b919b826.png";